import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'RQ_PERSIST_V1',
  throttleTime: 1000,
});
